package com.wintermar.inspection

import kotlin.Boolean
import kotlin.Long
import kotlin.String

public data class GetFullTemplate(
  public val template_id: String,
  public val template_name: String,
  public val version: Long?,
  public val publishedDate: String,
  public val numberOfPages: Long?,
  public val numberOfSections: Long?,
  public val numberOfQuestions: Long?,
  public val page_id: String?,
  public val page_title: String?,
  public val page_pos: Long?,
  public val section_id: String?,
  public val section_title: String?,
  public val section_pos: Long?,
  public val q_id: String?,
  public val questionText: String?,
  public val guidelines: String?,
  public val required: Boolean?,
  public val q_pos: Long?,
  public val answerType: String?,
  public val failedOptionId: String?,
  public val neutralOptionId: String?,
)
